﻿import {CreateDriverArguments} from "../../types/arguments/CreateDriverArguments";
import {ExecuteCustomerActionArguments} from "../../types/arguments/ExecuteCustomerActionArguments";
import IPermitsCustomActions from "../IPermitsCustomActions";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsCustomActions implements IPermitsCustomActions {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	create(data: CreateDriverArguments, signal?: AbortSignal | undefined): Promise<string> {
		return this._client.jsonFetch("drivers", "POST", data, {
			signal: signal
		});
	}

	get<T>(data: ExecuteCustomerActionArguments, signal?: AbortSignal | undefined): Promise<T> {
		return this._client.jsonFetch("customer/actions", "PUT", data, {
			signal: signal
		});
	}
}
